export enum Paths {
  Timeout = "/timeout",
  BrowserError = "/browserError",
  Error = "/error",
  AcsCallError = "/acsCallError",
  Home = "/",
}
